import axios from 'axios';
import Cookies from 'js-cookie';
import store from '../store';
import router from '../router';
import Swal from 'sweetalert2';
import logoutImage from '@/assets/images/logout.png';

const APICall = {
  
  install(app) {
    app.config.globalProperties.$call = {
      urlApi: import.meta.env.VITE_APP_API,
      //ChackPersonalInfo(callback, error) {
      //  var request = null;
      //  this.apiPostLogin('api/v0/SSO/ChackPersonalInfo', request, callback, error);
      //},
      Login(request, callback, error) {
        this.apiPostLogin('api/v0/Login/Login', request, callback, error);
      },
      AutoLogin(request, callback, error) {
        this.apiPostAuth('api/v0/Login/AutoLogin', request, callback, error);
      },
      ForgetPassword(param, callback, error) {
        this.apiGetAuth(`api/v0/Login/ForgetPassword?email=${param}`, callback, error);
      },
      ChatLogin(request, callback, error) {
        this.apiPostLoginChat('api/v0/Login/ChatLogin', request, callback, error);
      },
      CheckStatusSSO(request, callback, error) {
          this.apiPostAuth('api/v0/SSO/CheckStatusSSO', request, callback, error);
      },
      loginMicrosoft(callback, error) {
          this.apiGetAuth('api/v0/SSO/SignInChat', callback, error);
      },
      // เส้นนี้ยืนยันตัวตนด้วย cookie access_token (HttpOnly) ที่ backend เซ็ตไว้ตอน SSO SignIn
      // ถ้าไม่ส่ง withCredentials หน้าที่อยู่คนละ origin กับ API จะไม่แนบ cookie ให้แล้วโดน 401
      GetUserProfile(callback, error) {
        const request = null;
        this.apiPostAuth('api/v0/SSO/GetUserProfile', request, callback, error, true);
      },
      // เวอร์ชันเงียบสำหรับหน้า login ที่เรียกเองหลัง popup ปิด ผู้ใช้อาจแค่กดปิด popup ทิ้ง
      // ไม่ควรเด้ง Swal 'กรุณา Log in ใหม่' ใส่ ให้หน้า login จัดการข้อความเองแทน
      GetUserProfileSso(callback, error) {
        const request = null;
        this.apiPostAuthNoAlert('api/v0/SSO/GetUserProfile', request, callback, error, true);
      },
      GetUserChatProfile(callback, error) {
        const request = null;
        this.apiPostAuth('api/v0/SSO/GetUserChatProfile', request, callback, error);
      },
      SaveAgreeConsent(request, callback, error) {
        this.apiPostAuth('api/v0/User/SaveAgreeConsent', request, callback, error);
      },

      //UserManagement
      GetTableUserManagement(request, callback, error) {
        this.apiPostAuth('api/v0/User/GetTableUserManagement', request, callback, error);
      },
      CreateUser(request, callback, error) {
        this.apiPostAuth('api/v0/User/CreateUser', request, callback, error);
      },
      UpdateUser(request, callback, error) {
        this.apiPostAuth('api/v0/User/UpdateUser', request, callback, error);
      },
      UpdateUserProfile(request, callback, error) {
        this.apiPostAuth('api/v0/User/UpdateUserProfile', request, callback, error);
      },
      DeleteUser(param, callback, error) {
        this.apiDeleteAuth('api/v0/User/DeleteUser?id=' + param, callback, error);
      },
      SaveChangePassword(request, callback, error) {
        this.apiPostAuth('api/v0/User/SaveChangePassword', request, callback, error);
      },
      ChangePassword(request, callback, error) {
        this.apiPostAuth('api/v0/User/ChangePassword', request, callback, error);
      },
      GetTableUserChatManagement(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/GetTableUserManagement', request, callback, error);
      },
      CreateUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/CreateUser', request, callback, error);
      },
      UpdateUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/UpdateUser', request, callback, error);
      },
      GetUserChatQuotaDetail(userId, callback, error) {
        const cacheBust = Date.now();
        this.apiGetAuth(`api/v0/UserChat/GetUserQuotaDetail?userId=${encodeURIComponent(userId)}&_=${cacheBust}`, callback, error);
      },
      ResetUserChatQuota(userId, resetType, callback, error) {
        const cacheBust = Date.now();
        this.apiGetAuth(`api/v0/UserChat/ResetUserQuota?userId=${encodeURIComponent(userId)}&resetType=${encodeURIComponent(resetType)}&_=${cacheBust}`, callback, error);
      },
      DeleteUserChat(param, callback, error) {
        this.apiDeleteAuth('api/v0/UserChat/DeleteUser?id=' + param, callback, error);
      },
      SaveChangePasswordUserChat(request, callback, error) {
        this.apiPostAuth('api/v0/UserChat/SaveChangePasswordUserChat', request, callback, error);
      },
      DownloadTemplateUser(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/User/DownloadTemplateUser', request, callback, error);
      },
      ImportUser(request, Config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/User/ImportUser?isUserChat=${request.isUserChat}`, request.entity, Config, callback, error);
      },
      SyncUserChat(request, callback, error) {
          this.apiPostAuth('api/v0/SSO/SyncUserAzure', request, callback, error);
      },

      //BlacklistChatUser
      GetTableBlacklistChatUserManagement(request, callback, error) {
        this.apiPostAuth('api/v0/BlacklistChatUser/GetTableBlacklistChatUserManagement', request, callback, error);
      },
      GetLineUserID(callback, error) {
        this.apiGetAuth('api/v0/BlacklistChatUser/GetLineUserID', callback, error);
      },
      SetBlacklistChatUser(request, callback, error) {
        this.apiPostAuth('api/v0/BlacklistChatUser/SetBlacklistChatUser', request, callback, error);
      },
      DeleteBlacklistChatUser(request, callback, error) {
        this.apiPostAuth('api/v0/BlacklistChatUser/DeleteBlacklistChatUser', request, callback, error);
      },

      //GPTModel Management
      GetTableGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/GetTableGPTModel', request, callback, error);
      },
      GetTableGPTModelVersioning(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/GetTableGPTModelVersioning', request, callback, error);
      },
      GetGPTModelById(param, callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModel/GetGPTModelById?id=${param}`, callback, error);
      },
      PublishGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/PublishGPTModel', request, callback, error);
      },
      ReplaceGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/ReplaceGPTModel', request, callback, error);
      },
      AddGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/AddGPTModel', request, callback, error);
      },
      UpdateGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/UpdateGPTModel', request, callback, error);
      },
      DeleteGPTModel(param, callback, error) {
        this.apiDeleteAuth('api/v0/ManageGPTModel/DeleteGPTModel?id=' + param, callback, error);
      },
      DDGPTModel(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/DDGPTModel', callback, error);
      },
      DDGPTModelIsPublish(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/DDGPTModel_IsPublish', callback, error);
      },
      DDGPTModel_IsPublishByUser(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/DDGPTModel_IsPublishByUser', callback, error);
      },
      GetAllDDModelManagement(id,callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/GetDataForConfigModel?id=' + id, callback, error);
      },
      GetDDLModelDataAzureProvider(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModel/GetDDLModelDataAzureProvider', callback, error);
      },
      ExportFileConfigModel(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/ManageGPTModel/ExportFileConfigModel`, request, callback, error);
      },
      ImportFileModelConfig(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModel/ImportFileModelConfig', request, callback, error);
      },

      // GPTModelCategory
      GetGPTModelCategory(callback, error) {
        this.apiGetAuth('api/v0/GPTModelCategory/GetAll', callback, error);
      },
      AddGPTModelCategory(request, callback, error) {
        this.apiPostAuth('api/v0/GPTModelCategory/Add', request, callback, error);
      },
      UpdateGPTModelCategory(request, callback, error) {
        this.apiPostAuth('api/v0/GPTModelCategory/Update', request, callback, error);
      },
      DeleteGPTModelCategory(param, callback, error) {
        this.apiGetAuth('api/v0/GPTModelCategory/Delete?id=' + param, callback, error);
      },

      //GPTModelNode Management
      GetTableGPTModelNode(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetTableGPTModelNode', request, callback, error);
      },
      GetGPTModelNodeById(param, callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/GetGPTModelNodeById?id=${param}`, callback, error);
      },
      AddGPTModelNode(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/AddGPTModelNode', request, callback, error);
      },
      UpdateGPTModelNode(request, callback, error) {
        this.apiPutAuth('api/v0/ManageGPTModelNode/UpdateGPTModelNode', request, callback, error);
      },
      DeleteGPTModelNode(param, callback, error) {
        this.apiDeleteAuth('api/v0/ManageGPTModelNode/DeleteGPTModelNode?id=' + param, callback, error);
      },
      GetDDLVector(callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/GetDDLVector`, callback, error);
      },
      GetDDVectorDBNameManagement(callback, error) {
        this.apiGetAuth(`api/v0/ManageGPTModelNode/GetDDVectorDBNameManagement`, callback, error);
      },

      //Upload CSV
      GetMaxLimitedCharacter(callback, error) {
        this.apiGetAuth(`api/v0/Chat/GetMaxLimitedCharacter`, callback, error);
      },
      GetMaxLimitedCharacter_FullStream(Token, callback, error) {
        this.apiGetToken(`api/v0/Chat/GetMaxLimitedCharacterFullStream`, callback, error, Token);
      },
      UploadCSV2Vector(request, callback, error) {
        let url =  `api/v0/Chat/UploadFile?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        if(request.customCharacter != null){
          url += `&customCharacter=${request.customCharacter}`;
        }
        if (request.groupReplaceID != null) {
          url += `&groupReplaceID=${request.groupReplaceID}`;
        }
        if (request.EventCreate != null) {
          url += `&EventCreate=${request.EventCreate}`;
        }
        this.apiPostTypeFileNoResponseAuth(
          url,
          request.entity,
          callback,
          error
        );
      },
      UploadCSV2VectorNew(formData, eventCreate, callback, error) {
        let url = `api/v0/Chat/UploadFile?EventCreate=${eventCreate}`;
        this.apiPostTypeFileNoResponseAuth(
          url,
          formData,
          callback,
          error
        );
      },
      UploadCSV2Vector2(request, callback, error, Token) {
        let url =  `api/v0/Chat/UploadFile?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        if(request.customCharacter != null){
          url += `&customCharacter=${request.customCharacter}`;
        }
        if (request.groupReplaceID != null) {
          url += `&groupReplaceID=${request.groupReplaceID}`;
        }
        this.apiPostTypeFileNoResponseAuth(
          url,
          request.entity,
          callback,
          error,
          Token
        );

      },
      SaveEditVector(request, callback, error) {
        this.apiPostAuth(
          `api/v0/Chat/SaveEditVector`,
          request,
          callback,
          error
        );
      },
      SaveAddVector(request, callback, error) {
        this.apiPostAuth(
          `api/v0/Chat/SaveAddVector`,
          request,
          callback,
          error
        );
      },
      VectorOnOff(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/VectorOnOff', request, callback, error);
      },
      UploadCSVAnswers(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/UploadCSVAnswers', request, callback, error);
      },
      GetVectorDBName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBName', request, callback, error);
      },
      GetVectorDBNameByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameByName', request, callback, error);
      },
      GetViewVectorDBNameByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetViewVectorDBNameByName', request, callback, error);
      },
      GetPrivateVectorDBNameByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetPrivateVectorDBNameByName', request, callback, error);
      },
      DeleteVectorDBNameByName(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ManageGPTModelNode/DeleteVectorDBNameByName?vectorDBName=${param}`, callback, error);
      },
      UpdatePersonalInformation(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/UpdatePersonalInformation', request, callback, error);
      },
      DeleteVectorDBNameById(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ManageGPTModelNode/DeleteVectorDBNameById?id=${param}`, callback, error);
      },
      ReProcessedVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReProcessed', request, callback, error);
      },
      ReFreshVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReFreshVector', request, callback, error);
      },
      ReFreshViewVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReFreshViewVector', request, callback, error);
      },
      ReFreshPrivateVector_Stream(request, callback, error) { 
        this.apiPostAuth('api/v0/Chat/ReFreshPrivateVectorStream', request, callback, error);
      },
      ReFreshPrivateVector_FullStream(request, Token, callback, error) { 
        this.apiPostToken('api/v0/Chat/ReFreshPrivateVectorFullStream', request, callback, error, Token);
      },
      GetTableVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/GetTableVector', request, callback, error);
      },
      GetVectorCSVExport(param, callback, error) {
        this.apiGetAuth(`api/v0/Chat/GetVectorCSVExport?vectordbname=${param}`, callback, error);
      },
      GetVectorExcelExport(param, callback, error) {
        this.apiGetBlobAuth(`api/v0/Chat/GetVectorExcelExport?vectordbname=${param}`, callback, error);
      },
      DownloadTemplateVector_Stream(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Chat/DownloadTemplateVectorStream`,request, callback, error);
      },
      DownloadTemplateVector_FullStream(request, Token, callback, error) {
          this.apiPostTypeFileToken(`api/v0/Chat/DownloadTemplateVectorFullStream`,request, callback, error, Token);
      },
      DownloadUserManual(callback, error) {
        this.apiGetAuth(`api/v0/Chat/DownloadUserManual`, callback, error);
      },
      SaveDuplicateVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/SaveDuplicateVector', request, callback, error);
      },
      SaveReplaceVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/SaveReplaceVector', request, callback, error);
      },
      GetTableVectorVersion(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/GetTableVectorVersion', request, callback, error);
      },
      SaveReStoreVector(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/SaveReStoreVector', request, callback, error);
      },
      UploadCSV2Vector_Stream_Old(request, callback, error) {
        let url =  `api/v0/Chat/UploadFilePrivateStream?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
        if(request.customCharacter != null){
          url += `&customCharacter=${request.customCharacter}`;
        }
        if (request.groupReplaceID != null) {
          url += `&groupReplaceID=${request.groupReplaceID}`;
        }
        if (request.MaxLimitedCharacter != null) {
          url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        }
        this.apiPostTypeFileNoResponseAuth(
          url,
          request.entity,
          callback,
          error
        );
      },
      UploadCSV2Vector_Stream(request, callback, error) {
        let url =  `api/v0/Chat/UploadFilePrivateStream`
        this.apiPostTypeFileMultipart(url, request, callback, error);
      },
      UploadCSV2Vector_FullStream(request, Token, callback, error) {
        let url =  `api/v0/Chat/UploadFilePrivateFullStream`
        this.apiPostTypeFileMultipartToken(url, request, callback, error, Token);
      },
      ReProcessedVector_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/Chat/ReProcessedPrivateStream', request, callback, error);
      },
      ReProcessedVector_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/Chat/ReProcessedPrivateFullStream', request, callback, error, Token);
      },
      GetTablePrivateVectorVersion_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTablePrivateVectorVersionStream', request, callback, error);
      },
      GetTablePrivateVectorVersion_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetTablePrivateVectorVersionFullStream', request, callback, error, Token);
      },
      SaveReStorePrivateVector_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/SaveReStorePrivateVectorStream', request, callback, error);
      },
      SaveReStorePrivateVector_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/SaveReStorePrivateVectorFullStream', request, callback, error, Token);
      },
      PrivateVectorOnOff_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/PrivateVectorOnOffStream', request, callback, error);
      }, 
      PrivateVectorOnOff_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/PrivateVectorOnOffFullStream', request, callback, error, Token);
      },
      PrivateVectorOnOffByFileID_Stream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/PrivateVectorOnOffByFileIDStream', request, callback, error);
      },
      PrivateVectorOnOffByFileID_FullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/PrivateVectorOnOffByFileIDFullStream', request, callback, error, Token);
      },

      //DataIntegration
      GetDDdataintegration(callback, error) {
        this.apiGetAuth(`api/v0/DataIntegration/GetDDdataintegration`, callback, error);
      },
      GetTableDataIntegration(request,callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/GetTableDataIntegration`,request, callback, error);
      },
      GetDataIntegrationDetail(id,callback, error) {
        this.apiGetAuth(`api/v0/DataIntegration/GetDataIntegrationDetail?id=${id}`, callback, error);
      },
      AddDataIntegration_Table(request, callback , error){
        this.apiPostAuth(
          `api/v0/DataIntegration/AddDataIntegration_Table`,request.ReqData, callback, error);
      },
      AddDataIntegration_Data(request, callback , error){
        this.apiPostTypeFileNoResponseAuth(
          `api/v0/DataIntegration/AddDataIntegration_Data?id=${request.id}&deleteAll=${request.deleteAll}`, request.uploaded_file, callback, error);
      },
      UpdateDataIntegration(request,callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/UpdateDataIntegration`,request, callback, error);
      },
      DeleteDataIntegration(id, callback, error) {
        this.apiDeleteAuth(`api/v0/DataIntegration/DeleteDataIntegration?id=${id}`, callback, error);
      },
      GetDDLDataIntegration(callback, error) {
        this.apiGetAuth(`api/v0/DataIntegration/GetDDLDataIntegration`, callback, error);
      },
      TestConnection(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/TestConnection`, request, callback, error);
      },
      ValidateExternalColumn(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/ValidateExternalColumn`, request, callback, error);
      },
      AddDataIntegrationConnection(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/AddDataIntegrationConnection`, request, callback, error);
      },
      GetTableDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/GetTableDataIntegrationDetail`, request, callback, error);
      },
      AddDataDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/AddDataDataIntegrationDetail`, request, callback, error);
      },
      UpdateDataDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/UpdateDataDataIntegrationDetail`, request, callback, error);
      },
      DeleteDataDataIntegrationDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/DataIntegration/DeleteDataDataIntegrationDetail`, request, callback, error);
      },

      //Intent
      GetTableIntentGroup(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/GetTableIntentGroup`,request, callback, error);
      },
      GetTableIntentSession(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/GetTableIntentSession`,request, callback, error);
      },
      GetIntentSessionDetailById(id,callback, error) {
        this.apiGetAuth(`api/v0/Intent/GetIntentSessionDetailById?Id=${id}`, callback, error);
      },
      DDIntentSession(callback, error) {
        this.apiGetAuth(`api/v0/Intent/DDIntentSession`, callback, error);
      },
      DDIntentGroup(callback, error) {
        this.apiGetAuth(`api/v0/Intent/DDIntentGroup`, callback, error);
      },
      CreateIntentGroup(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/CreateIntentGroup`,request, callback, error);
      },
      UpdateIntentGroup(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/UpdateIntentGroup`,request, callback, error);
      },
      DeleteIntentGroup(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/DeleteIntentGroup`,request, callback, error);
      },
      CreateIntentSession(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/CreateIntentSession`,request, callback, error);
      },
      UpdateIntentSession(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/UpdateIntentSession`,request, callback, error);
      },
      DeleteIntentSession(request,callback, error) {
        this.apiPostAuth(`api/v0/Intent/DeleteIntentSession`,request, callback, error);
      },

      //ModelAndVectorManagement
      GetVectorDBNameMappinghGPTModel(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameMappinghGPTModel', request, callback, error);
      },
      GetVectorDBNameMappinghGPTModelByName(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameMappinghGPTModelByName', request, callback, error);
      },
      GetVectorDBNameMappinghGPTModelById(request, callback, error) {
        this.apiPostAuth('api/v0/ManageGPTModelNode/GetVectorDBNameMappinghGPTModelById', request, callback, error);
      },
      GetDDVectorDBName(callback, error) {
        this.apiGetAuth('api/v0/ManageGPTModelNode/GetDDVectorDBName', callback, error);
      },
      UpdateVectorDBNameMappinghGPTModel(request, callback, error) {
        this.apiPutAuth(`api/v0/ManageGPTModelNode/UpdateVectorDBNameMappinghGPTModel`, request, callback, error);
      },
      DeleteVectorDBNameMappinghGPTModel(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ManageGPTModelNode/DeleteVectorDBNameMappinghGPTModel?vectorDBName=${param}`, callback, error);
      },

      //Userprofile
      GetUserById(callback, error) {
        this.apiGetAuth(`api/v0/User/GetUserById`, callback, error);
      },

      //LogMessage
      GetTableLogMessage(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetTableLogMessage', request, callback, error);
      },
      GetExportCSVLogMessage(request, callback, error) {
        this.apiPostAuth('api/v0/Log/ExportCSVLogMessage', request, callback, error);
      },
      GetExportLogMonitoring(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportLogMonitoring`,request, callback, error);
      },
      GetExportLog(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportLog`,request, callback, error);
      },
      ExportFileQuestionSet(request, callback, error) {
        this.apiPostTypeFileAuth(`api/v0/Log/ExportFileQuestionSet`,request, callback, error);
      },
      ExportQuestionSet(request, callback, error) {
        this.apiPostAuth(`api/v0/Log/ExportQuestionSet`,request, callback, error);
      },
      GetEventLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/EventLogShow', request, callback, error);
      },
      GetLogReferenceFromLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetLogReference', request, callback, error);
      },
      GetLogMonitorFromLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetLogMonitor', request, callback, error);
      },
      GetLogDocumentReferenceFromLog(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetLogDocumentReference', request, callback, error);
      },
      GetLogMonitor(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetLogMonitor', request, callback, error);
      },
      GetApiExternal(request, callback, error) {
        this.apiPostAuth('api/v0/Log/GetApiExternal', request, callback, error);
      },
      GetApiExternalById(id, callback, error) {
        this.apiGetAuth(`api/v0/Log/GetApiExternalById?id=${id}`, callback, error);
      },
      ExportApiExternal(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/Log/ExportApiExternal', request, callback, error);
      },

      //Dashboard
      GetDashboardOverview(request,callback, error) {
        this.apiPostAuth('api/v0/Dashboard/Overview', request,callback, error);
      },

      //ChatServices
      // GetTopicAll(callback, error){
      //   this.apiGetAuth('api/v0/ChatHub/GetTopicAll', callback, error);
      // },
      GetTopicAll(request, callback, error){
        this.apiPostAuth('api/v0/ChatHub/GetTopicAll', request, callback, error);
      },
      GetHistoryMessage(request, Config, callback, error){
        this.apiPostAuthNoAlert_Config(`api/v0/ChatHub/GetHistoryMessage`,request,Config , callback, error);
      },
      AdminReplyStatus(id, status, callback, error){
        this.apiGetAuth(`api/v0/ChatHub/AdminReplyStatus?id=${id}&status=${status}`, callback, error);
      },
      LatestMessage(request, callback, error) {
        this.apiPostAuth('api/v0/ChatHub/LatestMessage', request, callback, error);
      },
      MarkAsRead(request, callback, error) {
        this.apiPostAuth('api/v0/Chathub/MarkAsRead', request, callback, error);
      },
      TopicUnread(callback, error) {
        this.apiGetAuth('api/v0/ChatHub/TopicUnread', callback, error);
      },
      //Setup
      // GetSetupOverview(request, callback, error) {
      //     const name = request.name;
      //     const index = request.index;
      //     const size = request.size;
      //     this.apiGetAuth(`api/v0/Setup/Overview?name=${name}&index=${index}&size=${size}`, callback, error);
      // },
      GetSetupOverview(callback, error) {
        this.apiGetAuth(`api/v0/Setup/Overview`, callback, error);
      },
      GetSetupOverviewGeneral(callback, error) {
        this.apiGetAuth(`api/v0/Setup/OverviewGeneral`, callback, error);
      },
      GetOverviewSocial(callback, error) {
        this.apiGetAuth(`api/v0/Setup/OverviewSocial`, callback, error);
      },
      GetTableGroupModel(callback, error) {
        this.apiPostAuth(`api/v0/Setup/GetTableGroupModel`, callback, error);
      },
      GetDDGroupModel(callback, error) {
        this.apiGetAuth(`api/v0/Setup/GetDDGroupModel`, callback, error);
      },
      GetSetupCreate(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/Create', request, callback, error);
      },
      CreateGroupModel(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/CreateGroupModel', request, callback, error);
      },
      GetSetupUpdate(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/Update', request, callback, error);
      },
      GetSetupUpdateGeneral(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateGeneral', request, callback, error);
      },
      UpdateSocial(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateSocial', request, callback, error);
      },
      ResetSnippetQuota(socialId, resetType, callback, error) {
        this.apiGetAuth(`api/v0/Setup/ResetSnippetQuota?socialId=${socialId}&resetType=${encodeURIComponent(resetType)}`, callback, error);
      },
      UpdateGroupModel(request, callback, error) {
        this.apiPostAuth('api/v0/Setup/UpdateGroupModel', request, callback, error);
      },
      GetSetupDelete(id, callback, error) {
        this.apiDeleteAuth(`api/v0/Setup/Delete?id=${id}`, callback, error);
      },
      DeleteGroupModel(id, callback, error) {
        this.apiDeleteAuth(`api/v0/Setup/DeleteGroupModel?id=${id}`, callback, error);
      },
      GetSetupApply(callback, error) {
        this.apiPostAuth(`api/v0/Setup/Apply`, callback, error);
      },

      //ModelQuick
      GetTableModelQuickGroup(callback, error) {
        this.apiPostAuth(`api/v0/ModelQuick/GetTableModelQuickGroup`, callback, error);
      },
      CreateModelQuickGroup(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/CreateModelQuickGroup', request, callback, error);
      }, 
      UpdateModelQuickGroup(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/UpdateModelQuickGroup', request, callback, error);
      },
      DeleteModelQuickGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ModelQuick/DeleteModelQuickGroup?id=${id}`, callback, error);
      },
      GetDDModelQuickGroup(callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetDDModelQuickGroup`, callback, error);
      },
      GetDDModelQuick(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/GetDDModelQuick', request, callback, error);
      }, 

      //Quick reply
      GetDDQuickReplyGroup(callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetDDQuickReplyGroup`, callback, error);
      },
      GetDDModelQuickReply(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/GetDDModelQuickReply', request, callback, error);
      }, 
      GetQuickReplyGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelQuick/GetQuickReplyGroup`, request, callback, error);
      },
      CreateQuickReplyGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelQuick/CreateQuickReplyGroup`, request, callback, error);
      },
      DeleteQuickReplyGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ModelQuick/DeleteQuickReplyGroup?id=${id}`, callback, error);
      },
      UpdateModelQuickReply(request, callback, error) {
        this.apiPostAuth('api/v0/ModelQuick/UpdateModelQuickReply', request, callback, error);
      },
      GetModelQuickGroup(callback, error) {
        this.apiGetAuth(`api/v0/ModelQuick/GetModelQuickGroup`, callback, error);
      },
      GetModelGroupAndQuickReply(id, callback, error){
        this.apiGetAuth(`api/v0/ModelQuick/GetModelGroupAndQuickReply?id=${id}`, callback, error)
      },
      GetModelQuickCommand(id, callback, error){
        this.apiGetAuth(`api/v0/ModelQuick/GetModelQuickCommand?id=${id}`, callback, error)
      },
      UploadImageModelQuick(request, callback, error) {
        let url =  `api/v0/ModelQuick/UploadFileImageModelQuick`;
        this.apiPostTypeFileNoResponseAuth(
          url,
          request.entity,
          callback,
          error
        );
      },

      //Replace text
      GetTableGroupReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/GetTableGroupReplaceText`, callback, error);
      },
      GetTableReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/GetTableReplaceText`, callback, error);
      },
      CreateGroupReplace(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/CreateGroupReplace`, callback, error);
      },
      CreateReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/CreateReplaceText`, callback, error);
      },
      UpdateReplaceText(callback, error) {
        this.apiPostAuth(`api/v0/ReplaceText/UpdateReplaceText`, callback, error);
      },
      DeleteGroupReplaceText(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ReplaceText/DeleteGroupReplaceText?id=${id}`, callback, error);
      },
      
      DeleteReplaceText(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ReplaceText/DeleteReplaceText?id=${id}`, callback, error);
      },
      GetDDGroupReplaceDB(callback, error) {
        this.apiGetAuth('api/v0/ReplaceText/GetDDGroupReplaceDB', callback, error);
      },
      GetDDGroupReplaceDBForVector(vectordbName, callback, error) {
        this.apiGetAuth(`api/v0/ReplaceText/GetDDGroupReplaceDBForVector?vectordbName=${vectordbName}`, callback, error);
      },
      UploadFileReplaceText(request, callback , error){
        this.apiPostTypeFileNoResponseAuth(
          `api/v0/ReplaceText/UploadFileReplaceText?groupName=${request.groupName}&deleteAll=${request.DeleteAll}&groupReplaceID=${request.groupReplaceID}`, request.uploaded_file, callback, error);
      },
      
      //Flow Management
      GetTableFlowManagement(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/GetTableFlowManagement', request, callback, error);
      },
      GetFlowById(id, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowById?id=${id}`, callback, error);
      },
      GetFlowByGroupFlowId(groupFlowId, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowByGroupFlowId?groupFlowId=${groupFlowId}`, callback, error);
      },
      GetFlowVersions(groupFlowId, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetFlowVersions?groupFlowId=${groupFlowId}`, callback, error);
      },
      CreateFlow(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/CreateFlow', request, callback, error);
      },
      UpdateFlow(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/UpdateFlow', request, callback, error);
      },
      DeleteFlow(id, callback, error) {
        this.apiPostAuth('api/v0/Flow/DeleteFlow', id, callback, error);
      },
      GetFlowDropdown(callback, error) {
        this.apiGetAuth('api/v0/Flow/GetFlowDropdown', callback, error);
      },
      TestEmailConnection(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/TestEmailConnection', request, callback, error);
      },
      GetWebhookKeys(flowGroupId, callback, error) {
        this.apiGetAuth(`api/v0/Flow/GetWebhookKeys?flowGroupId=${flowGroupId}`, callback, error);
      },
      CreateWebhookKey(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/CreateWebhookKey', request, callback, error);
      },
      DeleteWebhookKey(request, callback, error) {
        this.apiPostAuth('api/v0/Flow/DeleteWebhookKey', request, callback, error);
      },

      // Agent Tool Management
      GetTableAgentTool(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool/search', request, callback, error);
      },
      SearchAgentTools(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool/search', request, callback, error);
      },
      GetAgentToolDropdown(callback, error) {
        this.apiGetAuth('api/v1/AgentTool/GetAgentToolDropdown', callback, error);
      },
      GetAgentTools(includeInactive, callback, error) {
        this.apiGetAuth(`api/v1/AgentTool?includeInactive=${includeInactive === true}`, callback, error);
      },
      GetAgentToolById(id, callback, error) {
        this.apiGetAuth(`api/v1/AgentTool/${id}`, callback, error);
      },
      CreateAgentTool(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool', request, callback, error);
      },
      UpdateAgentTool(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool/UpdateAgentTool', request, callback, error);
      },
      TestAgentTool(request, callback, error) {
        this.apiPostAuth('api/v1/AgentTool/TestAgentTool', request, callback, error);
      },
      DeleteAgentTool(id, callback, error) {
        this.apiDeleteAuth(`api/v1/AgentTool/${id}`, callback, error);
      },

      // ============================================
      // DEBUG FLOW API
      // ============================================

      // Debug Flow via SSE (Server-Sent Events)
      // Returns raw fetch Response for streaming
      async DebugFlowSSE(request) {
        const headers = {
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream',
        };

        // Present the SAME credential the rest of the app uses. apiPostAuth/apiGetAuth
        // authenticate via axios.defaults Authorization (set at login in store.js) plus the
        // access_token cookie (withCredentials). On cross-origin staging the access_token cookie
        // is HttpOnly + cross-site, so the Bearer header from axios.defaults is the reliable path.
        // Falling back to the raw token storages keeps the previous behavior when axios.defaults
        // is not populated (e.g. snippet users).
        const axiosAuth = axios.defaults.headers.common['Authorization'];
        if (axiosAuth) {
          headers.Authorization = axiosAuth; // already in "Bearer <token>" form
        } else {
          const fallbackToken = [
            sessionStorage.getItem('token'),
            localStorage.getItem('token'),
            store?.state?.token,
            sessionStorage.getItem('token_Snippet'),
            localStorage.getItem('token_Snippet'),
            Cookies.get('token_Snippet'),
          ].find((value) => value && value !== 'null' && value !== 'undefined');
          if (fallbackToken) {
            const normalizedToken = fallbackToken.replace(/^Bearer\s+/i, '').trim();
            headers.Authorization = `Bearer ${normalizedToken}`;
          }
        }

        return fetch(`${this.urlApi}api/v0/FlowEngine/DebugFlow`, {
          method: 'POST',
          headers,
          credentials: 'include',
          body: JSON.stringify(request),
        });
      },

      // Resume a paused debug session
      DebugResume(sessionId, request, callback, error) {
        this.apiPostAuth(`api/v0/FlowEngine/DebugResume/${sessionId}`, request, callback, error);
      },

      // Stop a running/paused debug session
      DebugStop(sessionId, callback, error) {
        this.apiPostAuth(`api/v0/FlowEngine/DebugStop/${sessionId}`, null, callback, error);
      },

      //LLM Utility (central LLM helper endpoints)
      GenerateAdvancedRouterPrompt(request, callback, error) {
        this.apiPostAuth('api/v0/LLMUtility/GenerateAdvancedRouterPrompt', request, callback, error);
      },
      TestAdvancedRouterPrompt(request, callback, error) {
        this.apiPostAuth('api/v0/LLMUtility/TestAdvancedRouterPrompt', request, callback, error);
      },
      TestIntentRouterPrompt(request, callback, error) {
        this.apiPostAuth('api/v0/LLMUtility/TestIntentRouterPrompt', request, callback, error);
      },
      TestAIModelPrompt(request, callback, error) {
        this.apiPostAuth('api/v0/LLMUtility/TestAIModelPrompt', request, callback, error);
      },

      //Validation Generate
      GetTableValidationGenerate(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationGenerate/GetTableValidationGenerate`, request, callback, error);
      },
      CreateValidationGenerate(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationGenerate/CreateValidationGenerate`, request, callback, error);
      },
      UploadValidationGenerate(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationGenerate/UploadValidationGenerate?id=${request.id}`, request.entity, callback, error);
      },
      DownloadCSVQuestions(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/DownloadCSVQuestions?id=${param}`, callback, error);
      },
      ReprocessValidationGenerate(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/ReprocessValidationGenerate?id=${param}`, callback, error);
      },
      GetValidationGenerateDD(callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/GetValidationGenerateDD`, callback, error);
      },
      GetValidationGenerateDetail(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/GetValidationGenerateDetail?GenerateID=${param}`, callback, error);
      },
      EditValidationGenerate(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationGenerate/EditValidationGenerate`, request, callback, error);
      },
      DeleteValidationGenerate(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationGenerate/DeleteValidationGenerate?GenerateID=${param}`, callback, error);
      },

      //Validation Process
      GetTableValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetTableValidationProcess`, request, callback, error);
      },
      CreateValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/CreateValidationProcess`, request, callback, error);
      },
      EditValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/EditValidationProcess`, request, callback, error);
      },
      UploadValidationProcess(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationProcess/UploadValidationProcess?id=${request.id}&GroupQuestion=${request.GroupQuestion}`, request.entity, callback, error);
      },
      DownloadCSVAnswer(request, callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/DownloadCSVAnswer?id=${request.id}&IsGroup=${request.isGroup}`, callback, error);
      },
      ReprocessValidationProcess(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/ReprocessValidationProcess?id=${param}`, callback, error);
      },
      SetReprocessValidationProcess(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/SetReprocessValidationProcess`, request, callback, error);
      },
      ReGenerateValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/ReGenerateValidationScore`, request, callback, error);
      },
      GetTableValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetTableValidationScore`, request, callback, error);
      },
      GetDashboardValidationScore(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationProcess/GetDashboardValidationScore`, request, callback, error);
      },
      GetDDValidationProcess(callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/DDValidationProcess`, callback, error);
      },
      GetValidationProcessDetail(param, callback, error) {
        this.apiGetAuth(`api/v0/ValidationProcess/GetValidationProcessDetail?ProcessID=${param}`, callback, error);
      },
      DeleteValidationProcess(param, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationProcess/DeleteValidationProcess?ProcessID=${param}`, callback, error);
      },
      ValidateCSV(formFile, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationProcess/ValidateCSV`, formFile, callback, error);
      },

      //Validation Positive
      GetTableValidationPositive(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/GetTableValidationPositive`, request, callback, error);
      },
      GetTableValidationPositiveDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/GetTableValidationPositiveDetail`, request, callback, error);
      },
      UploadValidationPositive(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationPositive/UploadValidationPositive?name=${request.name}&type=${request.type}`, request.entity, callback, error);
      },
      DeleteValidationPositive(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationPositive/ValidationPositive?name=${request}`, callback, error);
      },
      AddValidationPositiveDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/ValidationPositiveDetailAdd`, request, callback, error);
      },
      EditValidationPositiveDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationPositive/ValidationPositiveDetailEdit`, request, callback, error);
      },
      DeleteValidationPositiveDetail(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationPositive/ValidationPositiveDetailDelete?id=${request}`, callback, error);
      },

      //Validation Negative
      GetTableValidationNegative(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationNegative/GetTableValidationNegative`, request, callback, error);
      },
      GetTableValidationNegativeDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/ValidationNegative/GetTableValidationNegativeDetail`, request, callback, error);
      },
      UploadValidationNegative(request, callback, error) {
        this.apiPostTypeFileNoResponseAuth(`api/v0/ValidationNegative/UploadValidationNegative?name=${request.name}`, request.entity, callback, error);
      },
      DeleteValidationNegative(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationNegative/ValidationNegativeDelete?name=${request}`, callback, error);
      },
      DeleteValidationNegativeDetail(request, callback, error) {
        this.apiDeleteAuth(`api/v0/ValidationNegative/ValidationNegativeDetailDelete?id=${request}`, callback, error);
      },
      
      //#region Folder
      GetFolders(request, callback, error) {
        const payload = typeof request === 'string' ? JSON.stringify(request) : request;
        this.apiPostAuth('api/v0/Folder/GetFolders', payload, callback, error);
      },
      GetFolderById(id, callback, error) {
        this.apiGetAuth(`api/v0/Folder/GetFolderById?id=${id}`, callback, error);
      },
      CreateFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/CreateFolder', request, callback, error);
      },
      UpdateFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/UpdateFolder', request, callback, error);
      },
      DeleteFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/DeleteFolder', request, callback, error);
      },
      AddTopicToFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/AddTopicToFolder', request, callback, error);
      },
      RemoveTopicFromFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/RemoveTopicFromFolder', request, callback, error);
      },
      MoveTopicToFolder(request, callback, error) {
        this.apiPostAuth('api/v0/Folder/MoveTopicToFolder', request, callback, error);
      },
      //#endregion

      // Master Data
      GetModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/GetModelData`, request, callback, error);
      },
      GetAllLLMModelData(Token, callback, error) {
        Token = Token == null ? "" : Token;
        this.apiGetToken('api/v0/GPTStream/GetALLModelData', callback, error, Token);
      },
      GetDDLModelData(callback, error) {
        this.apiGetAuth(`api/v0/ModelData/GetDDLModelData`, callback, error);
      },
      CreateModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/CreateModelData`, request, callback, error);
      },
      UpdateModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/UpdateModelData`, request, callback, error);
      },
      DeleteModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/DeleteModelData`, request, callback, error);
      },
      GetModelDataInUse(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/GetModelDataInUse`, request, callback, error);
      },
      ReplaceAndDeleteModelData(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/ReplaceAndDeleteModelData`, request, callback, error);
      },
      
      GetPromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/GetPromptTemplate`, request, callback, error);
      },
      AddPromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/AddPromptTemplate`, request, callback, error);
      },
      UpdatePromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/UpdatePromptTemplate`, request, callback, error);
      },
      DeletePromptTemplate(request, callback, error) {
        this.apiPostAuth(`api/v0/ModelData/DeletePromptTemplate`, request, callback, error);
      },
      GetPromptTemplateReadyUse(callback, error) {
        const request = {};
        this.apiPostAuth(`api/v0/ModelData/GetPromptTemplateReadyUse`, request, callback, error);
      },
      GetProviderData(request, callback, error) {
        this.apiPostAuth(`api/v0/ProviderData/GetProviderData`, request, callback, error);
      },
      GetDDLProviderData(callback, error) {
        this.apiGetAuth(`api/v0/ProviderData/GetDDLProviderData`, callback, error);
      },
      GetKeyJSON(callback, error) {
        const request = {};
        this.apiPostAuth(`api/v0/ModelData/GetKeyJSON`, request, callback, error);
      },

      //#region Stream
      GetTokenFullStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTokenFullStream', request, callback, error, true);
      },
      ChkTokenFullStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/ChkTokenFullStream', request, callback, error);
      },
      GptFullStreamPOST(request, Config, callback, error) {
        this.apiPostText_Stream('api/v0/GPTStream/GptFullStreamPOST', Config, request, callback, error);
      },
      GptStreamPOST(request, Config, callback, error) {
        this.apiPostText_Stream('api/v0/GPTStream/GptStreamPOST', Config, request, callback, error);
      },
      GetValidationNegativeDD(callback, error) {
        this.apiGetAuth(`api/v0/ValidationNegative/GetValidationNegativeDD`, callback, error);
      },
      GetValidationPositiveDD(callback, error) {
        this.apiGetAuth(`api/v0/ValidationPositive/GetValidationPositiveDD`, callback, error);
      },
      GetValidationPositiveDD2(callback, error) {
        this.apiGetAuth(`api/v0/ValidationPositive/GetValidationPositiveDD2`, callback, error);
      },

      GetLogStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetLogStream', request, callback, error);
      },

      GptFullStreamPostToken(request, Config, Token, callback, error) {
        this.apiPostTokenText_Stream('api/v0/GPTStream/GptFullStreamPOST', Config, request, callback, error, Token);
      },
      ChatPlayGroundStreamPOST(request, Config, callback, error) {
        this.apiPostText_Stream('api/v0/GPTStream/ChatPlayGroundStreamPOST', Config, request, callback, error);
      },

      GetModelQuickGroupInModelGroup(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetModelQuickGroupInModelGroup', request, callback, error, Token);
      }, 
      GetShortcutMenu(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetShortcutMenu', request, callback, error, Token);
      }, 
      //#endregion

      



      //#region Speech_To_Text 
      GetModelQuickGroupInModelGroupPostToken(request,Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetModelQuickGroupInModelGroup',  request, callback, error,Token);
      },


      



      // Speech_To_Text 
      GetConvest_Speech_To_Text(request, Config, callback, error) {
        this.apiPostImportFileAuth('api/v0/SpeechToText/Convest_Speech_To_Text', request, Config, callback, error);
      },
      GetSpeechDocument(request, callback, error)
      {
        this.apiPostAuth('api/v0/SpeechToText/SpeechDocumentShow', request, callback, error);
      },
      CreateSpeechDocument(request, config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/SpeechToText/CreateSpeechDocument`,request, config, callback, error);
      },
      GetSpeechDocumentStatus(id, callback, error) {
        this.apiGetAuth(`api/v0/SpeechToText/SpeechDocumentStatus?id=${id}`, callback, error);
      },
      UploadSpeechDocument(request, config, callback, error) {
        this.apiPostImportFileAuth(`api/v0/SpeechToText/UploadSpeechDocument`, request, config, callback, error);
      },
      GetSpeechDocumentDetail(request, callback, error)
      {
        this.apiPostAuth('api/v0/SpeechToText/GetSpeechDocumentDetail', request, callback, error);
      },
      EditSpeechDocumentDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/SpeechToText/EditSpeechDocument`, request, callback, error);
      },
      DeleteSpeechDocument(param, callback, error){
        this.apiDeleteAuth(`api/v0/SpeechToText/DeleteSpeechDocument?id=${param}`, callback, error);
      },
      DeleteSpeechDocumentDetail(param, callback, error){
        this.apiDeleteAuth(`api/v0/SpeechToText/DeleteSpeechDocumentDetail?id=${param}`, callback, error);
      },
      ImportSpeech2Text(request, callback, error) {
        this.apiPostAuth(
          `api/v0/Chat/ImportSpeech2Text`,
          request,
          callback,
          error
        );
      },
      SummarizedSpeechDocumentDetail(request, callback, error) {
        this.apiPostAuth(`api/v0/SpeechToText/SummarizedSpeechDocumentDetail`, request, callback, error
        );
      },
      //#endregion

      //#region History
      GetHistoryStream(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/GetHistoryStream', request, callback, error);
      },
      GetHistoryFullStream(request, token, callback, error) {
        this.apiPostAuthNoAlertToken('api/v0/GPTStream/GetHistoryFullStream', request, callback, error, token);
      },
      // GetLastLogID(request, callback, error) {
      //   this.apiPostAuthNoAlert('api/v0/GPTStream/GetLastLogID', request, callback, error);
      // },
      GetLastLogID(request, token ,callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetLastLogID', request, callback, error, token);
      },

      GetTopicStream(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/GetTopicStream', request, callback, error);
      },
      GetTopicFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetTopicFullStream', request, callback, error, Token);
      },

      GetTopicStreamToken(request, Token, callback, error) {
        Token = Token == null ? "" : Token;
        this.apiPostAuthNoAlertToken('api/v0/GPTStream/GetTopicFullStream', request, callback, error, Token);
      },


      // RenameTopicStream(request, callback, error) {
      //   this.apiPostAuthNoAlert('api/v0/GPTStream/RenameTopicStream', request, callback, error);
      // },
      RenameTopicStream(request, Token, callback, error) {
        Token = Token == null ? "" : Token;
        this.apiPostToken('api/v0/GPTStream/RenameTopicStream', request, callback, error, Token);
      },
      DeleteTopicStream(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/DeleteTopicStream', request, callback, error);
      },

      GetTopicIDStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetTopicIDStream', request, callback, error);
      },
      //#endregion


      //#region Private Memory
 
        GetDDGroupReplaceDB_Stream(callback, error) {
          this.apiGetAuth('api/v0/GPTStream/GetDDGroupReplaceDBStream', callback, error);
        },
        GetDDGroupReplaceDB_FullStream(Token, callback, error) {
          this.apiGetToken('api/v0/GPTStream/GetDDGroupReplaceDBFullStream', callback, error, Token);
        },
        UploadImage_Stream(request, callback, error) {
          let url =  `api/v0/GPTStream/UploadImageFileStream?USER_CHANNEL=${request.USER_CHANNEL}`;
          this.apiPostTypeFileNoResponseAuth(
            url,
            request.entity,
            callback,
            error
          );
        },
        UploadImage_FullStream(request, Token, callback, error) {
          let url =  `api/v0/GPTStream/UploadImageFileFullStream?USER_CHANNEL=${request.USER_CHANNEL}`;
          this.apiPostTypeFileNoResponseToken(
            url,
            request.entity,
            callback,
            error,
            Token
          );
        },
        // UploadCSV2Vector_Stream(request, callback, error) {
        //   let url =  `api/v0/GPTStream/UploadFile?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
        //   if(request.customCharacter != null){
        //     url += `&customCharacter=${request.customCharacter}`;
        //   }
        //   if (request.groupReplaceID != null) {
        //     url += `&groupReplaceID=${request.groupReplaceID}`;
        //   }
        //   if (request.MaxLimitedCharacter != null) {
        //     url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        //   }
        //   this.apiPostTypeFileNoResponseAuth(
        //     url,
        //     request.entity,
        //     callback,
        //     error
        //   );
        // },
        // UploadCSV2Vector_FullStream(request, callback, error) {
        //   let url =  `api/v0/GPTStream/UploadFileFullStream?modeltype=${request.modelType}&vectordbname=${request.vectordbName}&deleteAll=${request.deleteAll}&DetectLanguage=${request.DetectLanguage}&USER_CHANNEL=${request.USER_CHANNEL}&TopVDB=${request.topVDB}&FileName=${request.searchVectorDBName2}&FileId=${request.fileId}&cosine=${request.cosine}`;
        //   if(request.customCharacter != null){
        //     url += `&customCharacter=${request.customCharacter}`;
        //   }
        //   if (request.groupReplaceID != null) {
        //     url += `&groupReplaceID=${request.groupReplaceID}`;
        //   }
        //   if (request.MaxLimitedCharacter != null) {
        //     url += `&MaxLimitedCharacter=${request.MaxLimitedCharacter}`;
        //   }
        //   this.apiPostTypeFileNReFreshVector_FullStreamoResponseAuth(
        //     url,
        //     request.entity,
        //     callback,
        //     error
        //   );
        // },

        ReFreshVector_Stream(request,Config, callback, error) {
          this.apiPostAuthNoAlert_Config('api/v0/GPTStream/ReFreshVector_Stream', request, Config,callback, error);
        },
        ReFreshVector_FullStream(request,Config, Token, callback, error) {
          this.apiPostTokenText_Stream('api/v0/GPTStream/ReFreshVector_FullStream',Config, request, callback, error, Token);
        },
        // ReProcessedVector_Stream(request, callback, error) {
        //   this.apiPostAuth('api/v0/GPTStream/ReProcessed', request, callback, error);
        // },
        // ReProcessedVector_FullStream(request, callback, error) {
        //   this.apiPostAuth('api/v0/GPTStream/ReProcessedFullStream', request, callback, error);
        // },
        SaveEditVector_Stream(request, callback, error) {
          this.apiPostAuth(
            `api/v0/GPTStream/SaveEditVectorPrivateStream`,
            request,
            callback,
            error
          );
        },
        SaveEditVector_FullStream(request, Token, callback, error) {
          this.apiPostToken(
            `api/v0/GPTStream/SaveEditVectorPrivateFullStream`,
            request,
            callback,
            error,
            Token
          );
        },
        SaveAddVector_Stream(request, callback, error) {
          this.apiPostAuth(
            `api/v0/GPTStream/SaveAddVectorPrivateStream`,
            request,
            callback,
            error
          );
        },
        SaveAddVector_FullStream(request, Token, callback, error) {
          this.apiPostToken(
            `api/v0/GPTStream/SaveAddVectorPrivateFullStream`,
            request,
            callback,
            error,
            Token
          );
        },
        
      Delete_ListFilePM_ById_Stream (param, callback, error) {
        this.apiDeleteAuth(`api/v0/GPTStream/Delete_ListFilePM_ById_Stream?id=${param}`, callback, error);
      },
      Delete_ListFilePM_ById_FullStream (param, Token, callback, error) {
        this.apiDeleteToken(`api/v0/GPTStream/Delete_ListFilePM_ById_FullStream?id=${param}`, callback, error, Token);
      },
      DeleteVectorDBNameById_Stream(param, callback, error) {
        this.apiDeleteAuth(`api/v0/GPTStream/DeleteVectorDBNameById_Stream?id=${param}`, callback, error);
      },
      DeleteVectorDBNameById_FullStream(param, Token, callback, error) {
        this.apiDeleteToken(`api/v0/GPTStream/DeleteVectorDBNameById_FullStream?id=${param}`, callback, error, Token);
      },
      DeleteVectorDBNameByName_Stream(param, callback, error) {
        this.apiDeleteAuth(`api/v0/GPTStream/DeleteVectorDBNameByName_Stream?vectorDBName=${param.name}&FileId=${param.FileId}`, callback, error);
      },
      DeleteVectorDBNameByName_FullStream(param, Token, callback, error) {
        this.apiDeleteToken(`api/v0/GPTStream/DeleteVectorDBNameByName_FullStream?vectorDBName=${param.name}&FileId=${param.FileId}`, callback, error, Token);
      },
      SaveCosine_TopVDBStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/SaveCosine_TopVDBStream', request, callback, error);
      },
      SaveCosine_TopVDBFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/SaveCosine_TopVDBFullStream', request, callback, error, Token);
      },
      SaveFileName_PrivateMemoryStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/SaveFileName_PrivateMemoryStream', request, callback, error);
      },
      SaveFileName_PrivateMemoryFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/SaveFileName_PrivateMemoryFullStream', request, callback, error, Token);
      },
      CancelFileName_PrivateMemory(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/CancelFileName_PrivateMemory', request, callback, error);
      },
      GetListFile_PrivateMemoryStream(request, callback, error) {
        this.apiPostAuth('api/v0/GPTStream/GetListFile_PrivateMemoryStream', request, callback, error);
      },
      GetListFile_PrivateMemoryFullStream(request, Token, callback, error) {
        this.apiPostToken('api/v0/GPTStream/GetListFile_PrivateMemoryFullStream', request, callback, error, Token);
      },
      
      //#endregion



      // ExternalAPI
      GetCheckAnonymous(callback, error) {
        const request = {};
        this.apiPostAuth(`api/v0/ExternalAPI/GetCheckAnonymous`, request, callback, error);
      },

      
      GetModelFirst(request, callback, error) {
        this.apiPostAuthNoAlert('api/v0/GPTStream/GetModelFirst', request, callback, error);
      },

      //Report
      GetReportQuestion(request, callback, error) {
        this.apiPostAuth('api/v0/Report/ReportQuestionTop10', request, callback, error);
      },
      QuestionGenerate(request, callback, error) {
        this.apiPostAuth('api/v0/Report/QuestionGenerate', request, callback, error);
      },
      ReportUser(request, callback, error) {
        this.apiPostAuth('api/v0/Report/ReportUserTop10', request, callback, error);
      },
      ReportUserUse(request, callback, error) {
        this.apiPostAuth('api/v0/Report/ReportUserUse', request, callback, error);
      },
      ExportReportUserUse(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/Report/ExportReportUserUse', request, callback, error);
      },
      ReportTokenSum(request, callback, error) {
        this.apiPostAuth('api/v0/Report/TotalToken', request, callback, error);
      },
      ExportReportTokenSummation(request, callback, error) {
        this.apiPostTypeFileAuth('api/v0/Report/ExportReportTokenSummation', request, callback, error);
      },
      //APIToken

      GetAPITokenData(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/GetAPITokenData`, request, callback, error);
      },
      RenewAPIToken(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/RenewAPIToken`, request, callback, error);
      },
      CreateAPIToken(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/CreateAPIToken`, request, callback, error);
      },
      RevorkAPIToken(request, callback, error) {
        this.apiPostAuth(`api/v0/ApiToken/RevorkAPIToken`, request, callback, error);
      },

      // ReleaseNote
      GetReleaseNote(callback, error) {
        this.apiGetAuth(`api/v0/ReleaseNote/GetReleaseNote`, callback, error);
      },
      
      // Feedback
      FeedbackFromClient(request,callback, error){
        const Token = request.token;
        this.apiPostToken(`api/v0/Feedback/FeedbackFromClient`, request.data, callback, error, Token);
      },
      GetTableReportFeedback(request,callback, error){
        this.apiPostAuth(`api/v0/Feedback/GetTableReportFeedback`, request, callback, error);
      },
      ExportReportFeedback(request,callback, error){
        this.apiPostTypeFileAuth(`api/v0/Feedback/ExportReportFeedback`, request, callback, error);
      },
      //#region ConfigTheme
      GetThemeCompanyCodeQuery() {
        const routeQuery = router.currentRoute?.value?.query || {};
        const routeCompanyCode = routeQuery.companyCode || routeQuery.CompanyCode;
        const companyCode = Cookies.get('companyCode') || (Array.isArray(routeCompanyCode) ? routeCompanyCode[0] : routeCompanyCode);
        return companyCode ? `?companyCode=${encodeURIComponent(companyCode)}` : '';
      },
      SaveConfigTheme(request,callback, error){
        this.apiPostAuth(`api/v0/ConfigTheme/SaveConfigTheme`, request, callback, error);
      },
      UploadTheme(param,callback, error){
        const companyCode = Cookies.get('companyCode');
        if (companyCode && param?.formData && !param.formData.has('CompanyCode')) {
          param.formData.append('CompanyCode', companyCode);
        }

        this.apiPostImportFile(`api/v0/ConfigTheme/upload${this.GetThemeCompanyCodeQuery()}`,
          param.formData, 
          callback, 
          error);
      },
      GetImage(filename,callback, error) {
        this.apiGetBlobPublic(`api/v0/ConfigTheme/GetImage/${filename}${this.GetThemeCompanyCodeQuery()}`, callback, error);
      },
      GetSnippetLoginStatus(request, callback, error) {
        const params = new URLSearchParams();
        if (request?.domainName) {
          params.set('domainName', request.domainName);
        }
        if (request?.token) {
          params.set('token', request.token);
        }

        this.apiGetAuth(`api/v0/ExternalAPI/GetSnippetLoginStatus?${params.toString()}`, callback, error);
      },
      GetSnippetGreeting(request, callback, error) {
        const params = new URLSearchParams();
        if (request?.domainName) {
          params.set('domainName', request.domainName);
        }
        if (request?.token) {
          params.set('token', request.token);
        }
        // public endpoint (anonymous, cross-origin จาก embed) -> apiGetPublic เลี่ยง preflight/credentials ที่ทำให้ CORS error
        this.apiGetPublic(`api/v0/ExternalAPI/GetSnippetGreeting?${params.toString()}`, callback, error);
      },
      GetConfigThem(callback, error) {
        this.apiGetPublic(`api/v0/ConfigTheme/GetConfigThem${this.GetThemeCompanyCodeQuery()}`, callback, error);
      },
      SetDefault(callback,error){
        let request = {};
        this.apiPostAuth(`api/v0/ConfigTheme/setDefault${this.GetThemeCompanyCodeQuery()}`,request , callback, error);
      },
      //#endregoion

      //#region ConsentConfig
      GetConsentConfig(callback, error) {
        this.apiGetAuth(`api/v0/ConsentConfig/GetConsentConfig`, callback, error);
      },
      UpdateConsent(request, callback, error) {
        this.apiPostAuth('api/v0/ConsentConfig/UpdateConsent', request, callback, error);
      },
      GetViewVersion(callback, error) {
        this.apiGetAuth(`api/v0/ConsentConfig/GetViewVersion`, callback, error);
      },
      GetConsentById(request, callback, error) {
        this.apiPostAuth(`api/v0/ConsentConfig/GetConsentById`, request, callback, error);
      },
      //#endregoion

      //#region PromptTemplate 
      GetTableGroupPromptTemplate(callback, error) {
        this.apiPostAuth(`api/v0/GroupPromptTemplate/GetTableGroupPromptTemplate`, callback, error);
      },
      DeleteGroupPromptTemplate(id, callback, error) {
        this.apiDeleteAuth(`api/v0/GroupPromptTemplate/DeleteGroupPromptTemplate?id=${id}`, callback, error);
      },
      //#endregion 

      //#region File Management
      DownloadChatImage(request, token, callback, error) {
          if (token) {
            this.apiPostImageAuth('api/v0/GPTStream/DownloadChatImage', request, callback, error, token);
          } else {
            this.apiPostImageAuth('api/v0/FileManager/DownloadChatImage', request, callback, error);
          }
      },
      GetTableFileManager(request, callback, error) {
        this.apiPostAuth('api/v0/FileManager/GetTableFileManager', request, callback, error);
      },
      DeleteFileManager(id, callback, error) {
        this.apiDeleteAuth(`api/v0/FileManager/DeleteFileManager?id=${id}`, callback, error);
      },
      DeleteAllFileManager(fileIds, callback, error) {
        this.apiDeleteFileAuth(`api/v0/FileManager/DeleteAllFileManager`, fileIds, callback, error);
      },
      GetViewFileManagerById(id, callback, error) {
        this.apiPostAuth(`api/v0/FileManager/GetViewFileManagerById?id=${id}`, null, callback, error);
      },
      //#endregion 

      //#region SecurityGroup
      
      GetTableSecurityGroup(request,callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/GetTableSecurityGroup`, request, callback, error);
      },
      AddSecurityGroup(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/AddSecurityGroup`,request, callback, error);
      },
      SyncDataEntraIDGroup(id, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/SyncDataEntraIDGroup?id=${id}`,null, callback, error);
      },
      GetTableUserGroupManagement(request, callback, error) {
        this.apiPostAuth(`api/v0/SecurityGroup/GetTableUserGroupManagement`,request, callback, error);
      },
      DeleteSecurityGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/SecurityGroup/Delete?id=${id}`, callback, error);
      },
      GetTableSetupUserGroupManagement(request, callback, error){
        this.apiPostAuth(`api/v0/SecurityGroup/GetTableSetupUserGroupManagement`,request, callback, error);
      },
      GetSetupByID(id, callback, error){
        this.apiPostAuth(`api/v0/SecurityGroup/GetSetupByID?id=${id}`,null, callback, error);
      },
      DeleteUserByID(param, callback, error){
        this.apiDeleteAuth(`api/v0/SecurityGroup/DeleteUserByID?id=${param.id}&GroupID=${param.groupid}`, callback, error);
      },
      UpdateUserGroup(request, callback, error){
        this.apiPostAuth(`api/v0/SecurityGroup/UpdateUserGroup`, request, callback, error);
      },
      AddUserIntoGroup(request, callback, error){
        this.apiPostAuth(`api/v0/SecurityGroup/AddUserIntoGroup`, request, callback, error);
      },
      //#endregion
      SendFileMessage(request,config,callback,error){
        this.apiPostImportFileAuth(`api/v0/ChatHub/SendFileMessage?topic=${request.topic}&type=${request.type}`,request.files,config, callback, error);
      },

      // #region ShortcutMenu
      CreateShortcutMenuGroup(request, callback, error){
        this.apiPostAuth(`api/v0/ShortcutMenu/CreateShortcutMenuGroup`,request, callback, error);
      },
      UpdateShortcutMenuGroup(request, callback, error){
        this.apiPostAuth(`api/v0/ShortcutMenu/UpdateShortcutMenuGroup`,request, callback, error);
      }, 
      GetTableShortcutMenuGroup(request, callback, error){
        this.apiPostAuth(`api/v0/ShortcutMenu/GetTableShortcutMenuGroup`,request, callback, error);
      },
      DeleteShortcutMenuGroup(id, callback, error) {
        this.apiDeleteAuth(`api/v0/ShortcutMenu/DeleteShortcutMenuGroup?id=${id}`, callback, error);
      },
      GetShortcutMenuByID(param, callback, error) {
        this.apiGetAuth(`api/v0/ShortcutMenu/GetShortcutMenuByID?id=${param}`, callback, error);
      },
      GetDDShortcutMenu(callback, error) {
        this.apiGetAuth(`api/v0/ShortcutMenu/GetDDShortcutMenu`, callback, error);
      },

      // #region Product
      GetDDProductGroupList(callback, error) {
        this.apiGetAuth(`api/v0/Product/GetDDProductGroupList`, callback, error);
      },
      GetTableProductGroup(request, callback, error){
        this.apiPostAuth(`api/v0/Product/GetTableProductGroup`,request, callback, error);
      },
      GetProductDetailById(param, callback, error){
        this.apiGetAuth(`api/v0/Product/GetProductDetailById?id=${param}`, callback, error);
      },
      CreateCategory(request, callback, error){
        this.apiPostAuth(`api/v0/Product/CreateCategory`,request, callback, error);
      },
      CreateProduct(request, callback, error){
        this.apiPostImportFile(`api/v0/Product/CreateProduct`,request, callback, error);
      },
      DeleteProductGroup(request, callback, error){
        this.apiPostAuth(`api/v0/Product/DeleteProductGroup`,request, callback, error);
      },
      DeleteProduct(request, callback, error){
        this.apiPostAuth(`api/v0/Product/DeleteProduct`,request, callback, error);
      },
      ReprocessVectorProduct(request, callback, error){
        this.apiPostAuth(`api/v0/Product/ReprocessVectorProduct`,request, callback, error);
      },

      setCookie(name,value) {
        document.cookie = name + "=" + (value || "");
      },
      getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let c of ca) {
              while (c.startsWith(' ')) c = c.substring(1,c.length);
              if (c.startsWith(nameEQ)) return c.substring(nameEQ.length,c.length);
          }
          return null;
      },
      eraseCookie(name) {
          document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      },
      
      ClearUserInfo() {
        Object.keys(Cookies.get()).forEach(function (cookieName) {
          if (cookieName != "rememberMe") {
            Cookies.remove(cookieName);
          }
        });
      },
      Logout() {
        this.apiPostAuth('api/v0/Login/signout', null,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.ClearUserInfo();
              router.push('/login');
            }
          },
          (errorResource) => {
            console.error(errorResource);
          }
        );
      },
      ChatLogout() {
        Object.keys(Cookies.get()).forEach(function (cookieName) {
          if (cookieName != "rememberMe") {
            Cookies.remove(cookieName);
          }
        });
      },
      GetUserInfo() {
        let Usid = Cookies.get('UserId');
        let Codeid = Cookies.get('UserCode');
        let UserFullName = Cookies.get('UserName');

        let temp = Number.parseInt(Usid);
        return {
          UserId: temp,
          UserCode: Codeid,
          UserName: UserFullName,
        };
      },
      images: {
        logout: logoutImage,
      },
      // Shared axios success/error handlers extracted to remove duplicated .then/.catch blocks (SonarQube duplicated lines).
      // Behavior-neutral: invoked via `this._handle...` so `this` stays bound to $call (this.ClearUserInfo/images resolve as before).
      _handleThen(response, callback, error) {
        if (response.status === 200) {
          return callback(response.data);
        }
        return error(response);
      },
      _handleCatchAuth(error_, error) {
        if (error_.response?.status === 401) {
          this.ClearUserInfo();
          router.push('/login');
          Swal.fire({
            iconHtml: '<img style="width: 100%;" alt="edit" src="'+ this.images.logout +'" v-bind="attrs" v-on="on">',
            title: 'กรุณา Log in ใหม่',
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              icon: 'no-border'
            }
          });
          return error(error_);
        }
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'Something went wrong!',
          showConfirmButton: false,
          timer: 1500,
        });
        return error(error_);
      },
      _handleCatchVerbose(error_, error) {
        // error_.response มีเฉพาะตอนที่ server ตอบกลับจริง ถ้า callback ของ .then โยน error
        // (เช่น อ่าน field จาก data ที่เป็น null) error_.response จะเป็น undefined จึง log ตัว error แทน
        console.error("API Error:", error_?.response ?? error_); // ข้อผิดพลาดจาก API
        return this._handleCatchAuth(error_, error);
      },
      // Shared builder for the multipart vector jsonBody, extracted to remove the
      // duplicated 13-field object literal (SonarQube duplicated lines). Behavior-neutral.
      _buildVectorJsonBody(request) {
        return {
          vectorDBName: request.vectordbName,
          modelType: request.modelType,
          deleteAll: request.deleteAll,
          customCharacter: request.customCharacter,
          topVDB: request.topVDB,
          cosine: request.cosine,
          topicID: request.TopicID,
          userChannel: request.USER_CHANNEL,
          groupReplaceID: request.groupReplaceID,
          detectLanguage: request.DetectLanguage,
          fileId: request.fileId,
          fileName: request.searchVectorDBName2,
          maxLimitedCharacter: request.MaxLimitedCharacter,
        };
      },
      apiPostLogin(URL, request, callback, error) {
        const companyCode = request?.CompanyCode?.trim?.() || '';
        const instance = axios.create({
          timeout: 500000,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              Cookies.set('userId', response.data.data.userId);
              Cookies.set('username', response.data.data.username);
              Cookies.set('fullName', response.data.data.fullName);
              Cookies.set('roleId', response.data.data.roleId);
              if (companyCode) {
                Cookies.set('companyCode', companyCode);
              } else {
                Cookies.remove('companyCode');
              }
              Cookies.set('authenticated', true);
              store.state.status = 'success';
              store.state.token = response.data.data.token;
              store.state.userid = response.data.data.userId;
              store.state.username = response.data.data.username;
              store.state.user = response.data.data;
              store.state.fullName = response.data.data.fullName;
              store.state.roleId = response.data.data.roleId;
              store.state.isLoggedIn = true;
              localStorage.setItem('flag', 'us');
              localStorage.setItem('locale', 'en');
              store.state.languages = 'en';
              return callback(response.data);
            }
            return error(response);
          })
          .catch((error_) => {
            return error(error_);
          });
      },
      apiPostLoginChat(URL, request, callback, error) {
        const companyCode = request?.CompanyCode?.trim?.() || '';
        const instance = axios.create({
          timeout: 500000,
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              const adminCookies = new Set(['authenticated', 'userId', 'username', 'fullName', 'roleId']);
              Object.keys(Cookies.get()).forEach(function (cookieName) {
                if (cookieName != 'rememberMe' && !adminCookies.has(cookieName)) {
                  Cookies.remove(cookieName);
                }
              });
              if (companyCode) {
                Cookies.set('companyCode', companyCode);
              }
              return callback(response.data);
            }
            return error(response);
          })
          .catch((error_) => {
            return error(error_);
          });
      },
      
      apiPostAuth(URL, request, callback, error, withCredentials = false) {
        const axiosConfig = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        };
        if (withCredentials) {
          axiosConfig.withCredentials = true;
        }
        const instance = axios.create(axiosConfig);
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            console.error("Unexpected Status:", response.status); // กรณี status ไม่ใช่ 200
            return error(response);
          })
          .catch((error_) => this._handleCatchVerbose(error_, error));
      },
      apiPostImageAuth(URL, request, callback, error, Token) {
        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json-patch+json; charset=utf-8',
        };

        if (Token) {
          headers.Authorization = 'Bearer ' + Token;
        }

        const instance = axios.create({
          headers: headers,
          responseType: 'blob',
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }
            console.error("Unexpected Status:", response.status); // กรณี status ไม่ใช่ 200
            return error(response);
          })
          .catch((error_) => this._handleCatchVerbose(error_, error));
      },
     
      apiMultiPostAuth(URL, request, callback, error) {
        let formData = new FormData();
        formData.append('request', request);
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data' ,
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      
      apiPostAuthNoAlert_Config(URL, request,Config, callback, error) {

        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request,Config)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => error(error_));
      },
      apiPostAuthNoAlert(URL, request, callback, error, withCredentials = false) {

        const axiosConfig = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        };
        if (withCredentials) {
          axiosConfig.withCredentials = true;
        }
        const instance = axios.create(axiosConfig);
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => error(error_));
      },
      apiPostAuthNoAlertToken(URL, request, callback, error, Token) {

        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => {
            if (error_.response?.status === 403) {
              router.push('/AccessDenied');
              Swal.fire({
                //iconHtml: '<img style="width: 100%;" alt="edit" src="'+ self.images.logout +'" v-bind="attrs" v-on="on">',
                icon: 'error',
                title: 'Access Denied',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border'
                }
              });
              return error(error_);
            }
            return error(error_);
          });
      },
      apiPutAuth(URL, request, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .put(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostTypeFileAuth(URL, request, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
          responseType: 'blob',
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostTypeFileToken(URL, request, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            //'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
          responseType: 'blob',
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiGetTypeFileAuth(URL, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
          responseType: 'blob',
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostTypeFileNoResponseAuth(URL, request, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostTypeFileMultipart(URL, request, callback, error) {
        const jsonBody = this._buildVectorJsonBody(request);
        request.entity.append("jsonBody", JSON.stringify(jsonBody));
        
        const instance = axios.create({
          headers: {
            Accept: 'application/json'
            // "Content-Type": "multipart/form-data"
          },
        });
        instance.post(this.urlApi + URL, request.entity)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostTypeFileMultipartToken(URL, request, callback, error, Token) {
        const jsonBody = this._buildVectorJsonBody(request);
        request.entity.append("jsonBody", JSON.stringify(jsonBody));
        
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json'
            // Do not set "Content-Type" manually; axios will set the correct "multipart/form-data" boundary when sending FormData.
          },
        });
        instance.post(this.urlApi + URL, request.entity)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostTypeFileNoResponseToken(URL, request, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            // 'Content-Type': 'application/json-patch+json; charset=utf-8'
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiPostToken(URL, request, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => {
            if (error_.response?.status === 401) {
              this.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="'+ this.images.logout +'" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border'
                }
              });
              return error(error_);
            }
            else if (error_.response?.status === 403) {
              router.push('/AccessDenied');
              Swal.fire({
                //iconHtml: '<img style="width: 100%;" alt="edit" src="'+ self.images.logout +'" v-bind="attrs" v-on="on">',
                icon: 'error',
                title: 'Access Denied',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border'
                }
              });
              return error(error_);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(error_);
          });
        },
        apiGetBlobAuth(URL, callback, error) {
            const instance = axios.create({
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json-patch+json; charset=utf-8',
                },
                responseType: "blob",
            });
            instance
                .get(this.urlApi + URL)
                .then((response) => this._handleThen(response, callback, error))
                .catch((error_) => this._handleCatchAuth(error_, error));
        },
        
        apiGetBlobAuthData(URL, callback, error) {
          const instance = axios.create({
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json-patch+json; charset=utf-8',
              },
              responseType: "blob",
          });
          instance
              .get(this.urlApi + URL)
              .then((response) => {
                  if (response.status === 200) {
                      return callback(response);
                  }
                  return error(response);
              })
              .catch((error_) => this._handleCatchAuth(error_, error))
      },
      apiGetBlobPublic(URL, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
          },
          withCredentials: false,
          responseType: 'blob',
        });

        delete instance.defaults.headers.common.Authorization;

        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response);
            }

            return error(response);
          })
          .catch((error_) => error(error_));
      },
      apiGetAuth(URL, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiGetPublic(URL, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
          },
          withCredentials: false,
        });

        delete instance.defaults.headers.common.Authorization;

        instance
          .get(this.urlApi + URL)
          .then((response) => {
            if (response.status === 200) {
              return callback(response.data);
            }

            return error(response);
          })
          .catch((error_) => error(error_));
      },
      apiGetToken(URL, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .get(this.urlApi + URL)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => {
            if (error_.response?.status === 401) {
              this.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="'+ this.images.logout +'" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border'
                }
              });
              return error(error_);
            }
            else if (error_.response?.status === 403) {
              router.push('/AccessDenied');
              Swal.fire({
                //iconHtml: '<img style="width: 100%;" alt="edit" src="'+ self.images.logout +'" v-bind="attrs" v-on="on">',
                icon: 'error',
                title: 'Access Denied',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border'
                }
              });
              return error(error_);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
          });
      },
      apiDeleteAuth(URL, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .delete(this.urlApi + URL)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiDeleteToken(URL, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .delete(this.urlApi + URL)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => this._handleCatchAuth(error_, error));
      },
      apiDeleteFileAuth(URL, fileIds, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          }
        });
        instance
          .delete(this.urlApi + URL, {
            data: fileIds,
          })
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => {


            if (error_.response?.status === 401) {
              globalThis.ClearUserInfo();
              router.push('/login');
              Swal.fire({
                iconHtml: '<img style="width: 100%;" alt="edit" src="'+ globalThis.images.logout +'" v-bind="attrs" v-on="on">',
                title: 'กรุณา Log in ใหม่',
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  icon: 'no-border'
                }
              });
              return error(error_);
            }
            Swal.fire({
              icon: 'error',
              title: 'เกิดข้อผิดพลาด',
              text: 'Something went wrong!',
              showConfirmButton: false,
              timer: 1500,
            });
            return error(error_);
          });
      },
      apiPostText_Stream(URL, Config, request, callback, error) {

        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        const streamConfig = { ...Config, withCredentials: true };
        instance
          .post(this.urlApi + URL, request, streamConfig)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => {
            return error(error_);

          });
      },
      apiPostTokenText_Stream(URL, Config, request, callback, error, Token) {
        const instance = axios.create({
          headers: {
            Authorization: 'Bearer ' + Token,
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json; charset=utf-8',
          },
        });
        instance
          .post(this.urlApi + URL, request, Config)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => {
            return error(error_);

          });
      },

      apiPostImportFileAuth(URL, request, Config, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            "Content-Type": "multipart/form-data"
          },
        });
        instance
          .post(this.urlApi + URL, request, Config)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => error(error_));
      },

      apiPostImportFile(URL, request, callback, error) {
        const instance = axios.create({
          headers: {
            Accept: 'application/json',
            "Content-Type": "form-data"
          },
        });
        instance
          .post(this.urlApi + URL, request)
          .then((response) => this._handleThen(response, callback, error))
          .catch((error_) => error(error_));
      },

    };
  },
};

export default APICall;
